const COUNTRY_CODES = {
  GB: '+44', // UK
  IE: '+353', // Ireland
  PK: '+92', // Pakistan
  IN: '+91', // India
  PL: '+48', // Poland
}

export const validateEmail = (email) => {
  const regex = /^[a-z0-9]+[a-z0-9_]*(?:(\_[a-z0-9]*)*(\-[a-z0-9-]+)*(\.[a-z0-9]+)*)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[\-a-z0-9]+)*(\.[a-z]{2,})+$/ // eslint-disable-line
  return regex.test(String(email).toLowerCase())
}

export const validateName = (value) => {
  const regex = /^[a-z '-]+$/i // eslint-disable-line
  return regex.test(String(value).toLowerCase())
}

export const validatePostCode = (postcode) => {
  const regex = /^\s*[A-Z]{1,2}[0-9R][0-9A-Z]? {0,1}[0-9][ABD-HJLNP-UW-Z]{2}\s*$/i; // eslint-disable-line
  return regex.test(String(postcode).toLowerCase())
}

export const validateDate = (number) => {
  const date = number.replace(/\D/g, '')
  const regex = /^\d+$/; // eslint-disable-line
  const month = date.slice(0, 2)
  return regex.test(String(date)) && month < 13
}

export const isPastDate = (number) => {
  const currentMonth = new Date().getMonth() + 1
  const currentYear = new Date()
    .getFullYear()
    .toString()
    .substr(-2)
  const fields = number.replace(/\D/g, '')
  const month = fields.slice(0, 2)
  const year = fields.slice(2)
  if (year < currentYear || (year === currentYear && month < currentMonth)) {
    return false
  }
  return true
}

export const dirtyEmail = (email, kickbox) => {
  if (email.length === 0) {
    return {
      email,
      emailError: true,
      emailPristine: false,
    }
  } else if (!validateEmail(email)) {
    return {
      email,
      emailInvalid: true,
      emailPristine: false,
    }
  }
  if (typeof kickbox === 'function') {
    kickbox(email)
  }
  return {
    email,
    emailError: false,
    emailInvalid: false,
    emailPristine: false,
  }
}

export const emailChange = (email, pristine) => {
  if (!pristine && email.length === 0) {
    return {
      email,
      emailError: true,
      emailInvalid: false,
      noSuchUserError: false,
    }
  } else if (!pristine && !validateEmail(email)) {
    return {
      email,
      emailInvalid: true,
      emailError: false,
      noSuchUserError: false,
    }
  }
  return {
    email,
    emailInvalid: false,
    emailError: false,
    noSuchUserError: false,
  }
}

export const validatePassword = (password) => {
  const minChars = 8
  const maxChars = 128
  const passwordInValid = false
  if (password !== '') {
    return password.length < minChars || password.length > maxChars
      ? true
      : passwordInValid
  }
  return false
}

export const passwordChange = (password, pristine) => {
  if (!pristine && !password) {
    return {
      password,
      passwordError: true,
      shortPasswordError: false,
    }
  } else if (!pristine && password.length < 8) {
    return {
      password,
      shortPasswordError: true,
      passwordError: false,
    }
  }
  return {
    password,
    shortPasswordError: false,
    passwordError: false,
  }
}

export const dirtyPassword = (password) => {
  if (!password) {
    return {
      passwordPristine: false,
    }
  } else if (password.length < 8) {
    return {
      shortPasswordError: true,
      passwordPristine: false,
    }
  }
  return {
    password,
    passwordPristine: false,
  }
}

export const termsChange = (terms) => {
  if (!terms) {
    return {
      tnc: 'n',
      termsError: true,
    }
  }
  return {
    tnc: 'y',
    termsError: false,
  }
}

export const submittable = (email, password, terms, postCode) => {
  const errors = {}
  if (!email) {
    errors.emailError = true
  } else if (!validateEmail(email)) {
    errors.emailInvalid = true
  }
  if (!password) {
    errors.passwordError = true
  } else if (password.length < 8) {
    errors.shortPasswordError = true
  }
  if (!terms) {
    errors.termsError = true
  }
  if (!postCode) {
    errors.postCodeError = true
  } else if (!validatePostCode(postCode)) {
    errors.postCodeInvalid = true
  }
  return errors
}

export const validateWalmartNumber = (number, pristine) => {
  const regex = /^[\d]{10}$/; // eslint-disable-line
  const valid = regex.test(String(number))
  if (!pristine && !number) {
    return {
      walmartNumber: number,
      walmartNumberBlank: true,
      walmartNumberInvalid: false,
      walmartNumberError: true,
      walmartNumberPristine: false,
    }
  } else if (!pristine && !valid) {
    return {
      walmartNumber: number,
      walmartNumberBlank: false,
      walmartNumberInvalid: true,
      walmartNumberError: true,
      walmartNumberPristine: false,
    }
  }
  return {
    walmartNumber: number,
    walmartNumberBlank: false,
    walmartNumberInvalid: false,
    walmartNumberError: false,
  }
}

export const validateColleagueCardNumber = (number, pristine) => {
  const regex = /^[0-9 ]{19}$/ // eslint-disable-line
  const valid = regex.test(String(number))
  if (!pristine && !number) {
    return {
      cardNumber: number,
      cardNumberBlank: true,
      cardNumberInvalid: false,
      cardNumberError: true,
      cardNumberPristine: false,
    }
  } else if (!pristine && !valid) {
    return {
      cardNumber: number,
      cardNumberBlank: false,
      cardNumberInvalid: true,
      cardNumberError: true,
      cardNumberPristine: false,
    }
  }
  return {
    cardNumber: number,
    cardNumberBlank: false,
    cardNumberInvalid: false,
    cardNumberError: false,
  }
}

export const isNumber = (value) => {
  const numberRegex = new RegExp('^\\d+$')
  return numberRegex.test(value)
}

export const enchanceUsername = (value, isPhoneNumber, countryCode) => {
  if (
    isPhoneNumber &&
    value.length > 5 &&
    !value.startsWith('0') &&
    (
      countryCode === '+44' ||
      countryCode === '+353' ||
      countryCode === '+92'
    )
  ) {
    return `0${value}`
  }
  return value
}


export const validatePhoneNumber = (phoneNumber, countryCode) => {
  let phoneNumberLength = phoneNumber.length
  let isValidPhoneNumber
  let validatedPhoneNumber = phoneNumber

  switch (countryCode) {
    case COUNTRY_CODES.GB:
      if ((phoneNumberLength === 9 || phoneNumberLength === 10) && phoneNumber.charAt(0) !== '0') {
        validatedPhoneNumber = `0${validatedPhoneNumber}`
      } else if (phoneNumberLength >= 11) {
        validatedPhoneNumber = phoneNumber.substring(0, 11)
      }
      phoneNumberLength = validatedPhoneNumber.length
      if (validatedPhoneNumber.substring(0, 2) !== '01') {
        isValidPhoneNumber = phoneNumberLength === 11
      } else {
        isValidPhoneNumber = phoneNumberLength === 11 || phoneNumberLength === 10
      }
      return { isValidPhoneNumber, validatedPhoneNumber }

    case COUNTRY_CODES.IE:
      if (
        validatedPhoneNumber.charAt(0) !== '0' &&
        phoneNumberLength >= 6 &&
        phoneNumberLength <= 10
      ) {
        validatedPhoneNumber = `0${validatedPhoneNumber}`
      } else if (phoneNumberLength >= 11) {
        validatedPhoneNumber = phoneNumber.substring(0, 11)
      }
      phoneNumberLength = validatedPhoneNumber.length
      if (validatedPhoneNumber.charAt(0) === '0' && validatedPhoneNumber.charAt(1) !== '8') {
        isValidPhoneNumber = phoneNumberLength >= 7 && phoneNumberLength <= 11
      } else if (validatedPhoneNumber.substring(0, 2) === '08') {
        isValidPhoneNumber = phoneNumberLength === 10
      }
      return { isValidPhoneNumber, validatedPhoneNumber }

    case COUNTRY_CODES.PK:
      if (phoneNumberLength === 10 && phoneNumber.charAt(0) !== '0') {
        validatedPhoneNumber = `0${validatedPhoneNumber}`
      } else if (phoneNumberLength >= 11) {
        validatedPhoneNumber = phoneNumber.substring(0, 11)
      }
      phoneNumberLength = validatedPhoneNumber.length
      isValidPhoneNumber = phoneNumberLength === 11
      return { isValidPhoneNumber, validatedPhoneNumber }

    case COUNTRY_CODES.IN:
      validatedPhoneNumber = phoneNumber.substring(0, 10)
      phoneNumberLength = validatedPhoneNumber.length
      isValidPhoneNumber = phoneNumberLength === 10
      return { isValidPhoneNumber, validatedPhoneNumber }

    case COUNTRY_CODES.PL:
      validatedPhoneNumber = phoneNumber.substring(0, 9)
      phoneNumberLength = validatedPhoneNumber.length
      isValidPhoneNumber = phoneNumberLength === 9
      return { isValidPhoneNumber, validatedPhoneNumber }

    default:
      validatedPhoneNumber = phoneNumber.substring(0, 12)
      isValidPhoneNumber = validatedPhoneNumber.length >= 6 && validatedPhoneNumber.length <= 12
      return { isValidPhoneNumber, validatedPhoneNumber }
  }
}

export const firstNameValidation = (input) => {
  if (!input) return 'Enter a first name'
  return ''
}

export const lastNameValidation = (input) => {
  if (!input) return 'Enter a last name'
  return ''
}

export const titleValidation = (input) => {
  if (!input) return `Please select your title`
  return ''
}

export const checkDate = (date, pristine) => {
  if (!pristine && !date) {
    return {
      date,
      dateError: true,
      dateInvalid: false,
      datePast: false,
    }
  } if (!pristine && !validateDate(date)) {
    return {
      date,
      dateError: false,
      dateInvalid: true,
      datePast: false,
    }
  } if (!pristine && !isPastDate(date)) {
    return {
      date,
      datePast: true,
      dateError: false,
      dateInvalid: false,
    }
  }
  return {
    date,
    datePast: false,
    dateError: false,
    dateInvalid: false,
  }
}
